// Validação local da troca de senha (o servidor é a autoridade: política, histórico e senha atual — REQ-AUTH-003).
import { z } from 'zod';

/** Parte 3.9 `auth.password.minLength` (12) — só evita uma ida óbvia ao servidor. */
export const PASSWORD_MIN_LENGTH = 12;

export const CHANGE_PASSWORD_ACTION = 'account.change-password';

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, 'account.password.errors.required'),
    newPassword: z.string().min(PASSWORD_MIN_LENGTH, 'account.password.errors.minLength'),
    confirmPassword: z.string().min(1, 'account.password.errors.required'),
  })
  .refine((values) => values.newPassword === values.confirmPassword, {
    path: ['confirmPassword'],
    message: 'account.password.errors.mismatch',
  })
  .refine((values) => values.newPassword !== values.currentPassword, {
    path: ['newPassword'],
    message: 'account.password.errors.sameAsCurrent',
  });

export type ChangePasswordValues = z.infer<typeof changePasswordSchema>;
